// extracted by mini-css-extract-plugin
export var addToCartButton = "_o8-b";
export var arrowButtonContainer = "_o8-9";
export var arrowButtonIcon = "_o8-a";
export var carouselArrowButton = "_o8-6";
export var carouselElementContainer = "_o8-1";
export var galleryThumbnail = "_o8-d";
export var galleryThumbnailImage = "_o8-e";
export var left = "_o8-7";
export var productDisplayCarouselContainer = "_o8-0";
export var productTileContainer = "_o8-2";
export var productTileImage = "_o8-4";
export var productTileImageContainer = "_o8-3";
export var productTileTitle = "_o8-5";
export var right = "_o8-8";
export var sliderOverflow = "_o8-c";